import { IonContent, IonPage } from '@ionic/react';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { SyncResumeBanner } from '@lidea/shared/feature-offline';

import MobileHeader from './../mobile-header/mobile-header';

/* eslint-disable-next-line */
export interface MobilePageProps {
  children?: React.ReactNode;
  headerExtension?: JSX.Element;
  defaultBackHref?: string;
  backHref?: string;
}

export function MobilePage(props: MobilePageProps) {
  return (
    <IonPage>
      <MobileHeader
        defaultBackHref={props.defaultBackHref}
        headerExtension={props.headerExtension}
      />
      <SyncResumeBanner />

      <IonContent>{props.children}</IonContent>
    </IonPage>
  );
}

export default MobilePage;
